export default __webpack_public_path__ + "static/media/dots-left-bottom.3b5e263e.svg";